/**
 * Turns a machine id (snake_case or kebab-case, e.g. `create_video` or
 * `create-text-video`) into a human-readable Title Case display name
 * ("Create Video", "Create Text Video"). Used by the developer Tools and
 * Skills modals, where the id doubles as the identifier but a friendlier
 * label reads better as the tile heading.
 */
export function humanizeId(id: string): string {
    return id
        .split(/[_-]+/)
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
